// CardsListScreen - Tarot compendium
import React from 'react';
import { motion } from 'framer-motion';
import { Library } from 'lucide-react';
import { PageContainer, GlassCard } from '../layout/PageContainer';
import { TAROT_DECK_WITH_INFO } from '../../utils/tarotData';

export const CardsListScreen = () => {
    return (
        <PageContainer className="py-6">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="max-w-3xl mx-auto"
            >
                {/* Header */}
                <div className="flex items-center justify-center gap-3 mb-8">
                    <motion.div
                        animate={{ rotate: [0, 5, -5, 0] }}
                        transition={{ duration: 3, repeat: Infinity }}
                    >
                        <Library className="w-10 h-10 text-amber-400" />
                    </motion.div>
                    <h2 className="text-3xl sm:text-4xl font-serif text-amber-100">
                        The Tarot Compendium
                    </h2>
                </div>

                {/* Cards List */}
                <GlassCard className="max-h-[70vh] overflow-y-auto">
                    <div className="space-y-2">
                        {TAROT_DECK_WITH_INFO.map((card, index) => (
                            <motion.div
                                key={card.name}
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: index * 0.02 }}
                                className="flex items-start gap-3 p-3 rounded-xl bg-white/5 hover:bg-white/10 transition-colors"
                            >
                                <span className="text-2xl shrink-0">{card.emoji}</span>
                                <div>
                                    <h3 className="text-base font-serif font-medium text-amber-200">
                                        {card.name}
                                    </h3>
                                    <p className="text-sm text-purple-300/70 mt-0.5 leading-relaxed">
                                        {card.description}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </GlassCard>
            </motion.div>
        </PageContainer>
    );
};

export default CardsListScreen;
